import React, { useEffect } from "react";
// import PropTypes from "prop-types";
import { SearchInput } from "@components/common";
// import styles from "./styles/FilterLayout.module.css";
import {
  Button,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Popover,
  Row,
} from "react-bootstrap";
import { InputField, Paginator } from "@components";
import { useExplore } from "@hooks";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategoriesAction, getMyCoursesAction } from "@redux/actions";
import { useSearchParams } from "react-router-dom";
import { useFormik } from "formik";

const FilterLayout = ({
  children,
  pagination,
  isActive,
  hasFilterBar = true,
  size,
  free,
  currentStatus,
  hasFilter = true,
}) => {
  // state

  // variables
  const { search, sort, filter, resetFilters, changePageSize } = useExplore();
  const [searchParams, setSearchParams] = useSearchParams();

  // logics before hooks
  const handleChangePageSize = (event) => {
    changePageSize(event.target.value);
  };

  const handleFilterCategory = (event) => {
    filter({ CategoryId: [event.target.value] });
  };

  const handleOrder = (event) => {
    sort(event.target.value);
  };

  const handleSearch = (event) => {
    formik.handleChange(event);
    search(event.target.value);
  };

  const dispatch = useDispatch();
  const courseCategory = useSelector(
    (state) => state.category.allCategories.data
  );

  const { deleteCourse } = useSelector((state) => state.course);
  // hooks
  useEffect(() => {
    dispatch(getAllCategoriesAction());
    resetFilters([]);
  }, []);

  // console.log([searchParams.values()]);
  useEffect(() => {
    const Keyword = (searchParams.get("Keyword") || "")
      // .replace(/[^\w\s']|_/g, "")
      .replace(/\s+/g, " ")
      .trim();
    const Orderby = searchParams.get("Orderby");
    const PageSize = size ? size : Number(searchParams.get("PageSize")) || 5;
    const PageNumber = Number(searchParams.get("PageNumber")) || 1;
    const CategoryId = searchParams.get("CategoryId") || [];
    const status = currentStatus
      ? currentStatus
      : searchParams.get("status") || 4;
    const isFree = free ? free : searchParams.get("isFree") || [];
    const isDiscount = searchParams.get("isDiscount") || [];
    const rate = searchParams.get("rate") || [];
    // const [currentFilters] = searchParamsToObject(searchParams, defaultFilters);

    const params = {
      ...searchParams,
      Keyword,
      Orderby,
      PageSize,
      PageNumber,
      CategoryId,
      isActive: isActive,
      isFree,
      isDiscount,
      rate,
    };

    if (status != 4 || !status) {
      params.status = status;
    }

    dispatch(getMyCoursesAction(params));
  }, [dispatch, searchParams, deleteCourse]);

  // logics

  const formik = useFormik({
    initialValues: {
      status: "4",
      isFree: false,
      isDiscount: false,
      rate: "",
      startDate: "",
      endDate: "",
      keyword: "",
    },
    onSubmit: (values) => {
      const { status, isFree, isDiscount, rate } = values;
      filter({ status, isFree, isDiscount, rate });
      document.body.click();
    },
  });
  // UI partials
  const popover = (
    <Popover id="popover-basic" className="mw-100" style={{ width: "600px" }}>
      {/* <Popover.Header as="h3">Popover right</Popover.Header> */}
      <Popover.Body>
        <Container>
          <Row className="border-bottom mb-3">
            <Col lg={3}>
              <strong>Status</strong>
            </Col>
            <Col lg={9}>
              <div className="d-flex mb-3 align-items-center gap-2">
                <Form.Check
                  className=""
                  label="Approved"
                  value="1"
                  name="status"
                  type={"radio"}
                  onChange={formik.handleChange}
                  checked={formik.values.status == 1}
                />
                <Form.Check
                  onChange={formik.handleChange}
                  label="Pending"
                  value="0"
                  name="status"
                  type={"radio"}
                  checked={formik.values.status == 0}
                />
                <Form.Check
                  onChange={formik.handleChange}
                  label="Rejected"
                  value="2"
                  name="status"
                  type={"radio"}
                  checked={formik.values.status == 2}
                />
                <Form.Check
                  label="Blocked"
                  value="3"
                  name="status"
                  type={"radio"}
                  onChange={formik.handleChange}
                  checked={formik.values.status == 3}
                />
                <Form.Check
                  label="All"
                  value="4"
                  name="status"
                  type={"radio"}
                  onChange={formik.handleChange}
                  checked={formik.values.status == 4}
                />
              </div>
            </Col>
          </Row>

          <Row className="border-bottom mb-3 ">
            <Col lg={3}>
              <strong>Price</strong>
            </Col>
            <Col lg={9}>
              <div className="d-flex mb-3 align-items-center gap-2">
                <Form.Check
                  label="Free"
                  name="isFree"
                  type={"checkbox"}
                  value={formik.values.isFree}
                  onChange={formik.handleChange}
                  checked={formik.values.isFree}
                />
                <Form.Check
                  label="On Sale"
                  name="isDiscount"
                  type={"checkbox"}
                  onChange={formik.handleChange}
                  value={formik.values.isDiscount}
                  checked={formik.values.isDiscount}
                />
              </div>
            </Col>
          </Row>
          <Row className="border-bottom mb-3 ">
            <Col lg={3}>
              <strong>Rating</strong>
            </Col>
            <Col lg={9}>
              <Form>
                <div className="d-flex mb-3 align-items-center gap-3">
                  <Form.Check
                    label="4 Up"
                    name="rate"
                    type={"radio"}
                    value="4"
                    onChange={formik.handleChange}
                    checked={formik.values.rate == 4}
                  />
                  <Form.Check
                    label="3 Up"
                    name="rate"
                    type={"radio"}
                    value="3"
                    onChange={formik.handleChange}
                    checked={formik.values.rate == 3}
                  />
                  <Form.Check
                    label="2 Up"
                    name="rate"
                    value="2"
                    type={"radio"}
                    onChange={formik.handleChange}
                    checked={formik.values.rate == 2}
                  />
                  <Form.Check
                    label="All"
                    value="0"
                    name="rate"
                    type={"radio"}
                    onChange={formik.handleChange}
                    checked={formik.values.rate == 0}
                  />
                </div>
              </Form>
            </Col>
          </Row>
          {/* <Row className="border-bottom mb-3 pb-3">
            <Col lg={3}>
              <strong>Date</strong>
            </Col>
            <Col lg={9}>
              <div className="d-flex justify-content-between align-items-center gap-1">
                <InputField
                  name={"startDate"}
                  type={"date"}
                  placeholder="Select start date"
                  //   placeholder="dd-mm-yyyy"
                  value={formik.values.startDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  autoComplete="off"
                  touchedValue={formik.touched.startDate}
                  errorsValue={formik.errors.startDate}
                />
                <span>-</span>
                <InputField
                  name={"endDate"}
                  type={"date"}
                  placeholder="Select end date"
                  value={formik.values.endDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  autoComplete="off"
                  touchedValue={formik.touched.endDate}
                  errorsValue={formik.errors.endDate}
                />
              </div>
            </Col>
          </Row> */}
          <Row className=" ">
            <Col lg={3}>
              <Button
                variant="outline-primary"
                onClick={() => {
                  formik.resetForm({
                    values: {
                      status: "4",
                      isFree: false,
                      isDiscount: false,
                      rate: "",
                      startDate: "",
                      endDate: "",
                      keyword: "",
                    },
                  });
                  resetFilters([]);
                }}
              >
                Clear
              </Button>
            </Col>

            <Col className="text-right" lg={9}>
              <Button onClick={() => document.body.click()} variant="secondary">
                Cancel
              </Button>
              <Button
                className="ml-2"
                variant="primary"
                onClick={formik.handleSubmit}
              >
                Apply
              </Button>
            </Col>
          </Row>
        </Container>
      </Popover.Body>
    </Popover>
  );
  // effects

  // render
  return (
    <>
      {hasFilterBar && (
        <div className="filter d-flex justify-content-between align-items-center mb-4 gap-2">
          <SearchInput
            name="keyword"
            onChange={handleSearch}
            value={formik.values.keyword}
            className="flex-grow-1"
          />

          <Form.Select className="w-auto" onChange={handleFilterCategory}>
            <option value={""}>All Category</option>
            {courseCategory.flatMap((cat) => {
              return cat.subCategories.map((sub) => {
                return (
                  <option key={sub.id} value={sub.id}>
                    {sub.name}
                  </option>
                );
              });
            })}
          </Form.Select>

          <Form.Select className="w-auto" onChange={handleOrder}>
            <option>Order by</option>
            <option value="createdAt desc">Newest</option>
            <option value="createdAt asc">Oldest</option>
          </Form.Select>
          {hasFilter ? (
            <OverlayTrigger
              trigger="click"
              placement="bottom-end"
              overlay={popover}
              rootClose
            >
              <Button variant="outline-primary">
                <i className="bi bi-funnel"></i> Filter
              </Button>
            </OverlayTrigger>
          ) : null}
        </div>
      )}

      {children}

      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <span>Show</span>
          <Form.Select className="w-auto" onChange={handleChangePageSize}>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
          </Form.Select>
          <span>courses per page</span>
        </div>
        <Paginator data={pagination} />
      </div>
    </>
  );
};

/* required: display name */
FilterLayout.displayName = "FilterLayout";

/* required: props types */
FilterLayout.propTypes = {};

/* required: default props */
FilterLayout.defaultProps = {};

export { FilterLayout };
